var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pageflag)?_c('Echart',{ref:"charts",staticClass:"right_top_inner",attrs:{"id":"rightTop","options":_vm.option}}):_c('Reacquire',{staticStyle:{"line-height":"200px"},on:{"onclick":_vm.getData}},[_vm._v(" 重新获取 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }